import { render } from "./BaseEditor.vue?vue&type=template&id=7ff0aac6&scoped=true"
import script from "./BaseEditor.vue?vue&type=script&lang=js"
export * from "./BaseEditor.vue?vue&type=script&lang=js"

import "./BaseEditor.vue?vue&type=style&index=0&id=7ff0aac6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff0aac6"]])

export default __exports__